import React from "react";
import CardComponent from "./CardComponent";
import { useAuth } from "../context/AuthProvider";

import constant from "../utils/constants";

const TagMeetingAttendanceBox = () => {
  const { userDetail } = useAuth();

  const Data = [
    {
      heading: "Tag meeting",
      content:
        "Tag your daily meetings with Broker, dealer, Advisor, Banca Partner, Digital Partner, etc",
      icon: "/icons/Zuno star mobile app icon-09.png",
      redirectTo: "/tag-meeting",
    },
    {
      heading: "Regularize attendance",
      content: "Regularize your meetings as well as mark your days",
      icon: "/icons/Zuno star mobile app icon-07.png",
      redirectTo: "/regularized-attendance",
    },
    {
      heading: "Add conveyance",
      content: "Update your daily travel conveyance in just a few clicks.",
      icon: "/icons/Zuno star mobile app icon-04.png",
      redirectTo: "/add-conveyance",
    },
    // {
    //   heading: "Create user",
    //   content: "",
    //   icon: "/icons/Zuno star mobile app icon-01.png",
    //   redirectTo: "/create-user",
    // },
    // {
    //   heading: "Delete user",
    //   content: "",
    //   icon: "/icons/Zuno star mobile app icon-01.png",
    //   redirectTo: "/delete-user",
    // },
  ];

  return (
    <div>
      {Data.map((item, index) => {
        if (
          item.heading === "Create user" &&
          userDetail?.data?.user?.role !== constant.userRoles.ADMIN
        ) {
          return null;
        }
        return (
          <CardComponent
            key={index}
            heading={item.heading}
            content={item.content}
            Icon={item.icon}
            redirectTo={item.redirectTo}
          />
        );
      })}
    </div>
  );
};

export default TagMeetingAttendanceBox;
